import { CSSProperties } from 'react';

export const GioIcon = ({ style }: { style?: CSSProperties }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      fillRule='evenodd'
      clipRule='evenodd'
      style={style}
    >
      <path d='M17.5 16H6.5V11H17.5V16ZM8 14.5H16V12.5H8V14.5Z' />
      <path d='M17.5 10H6.5V5H17.5V10ZM8 8.5H16V6.5H8V8.5Z' />
      <path d='M19.1396 2C19.8908 2 20.5 2.54674 20.5 3.2207V18.7793C20.5 19.4111 19.9649 19.9306 19.2793 19.9932L19.1396 20H16.5996V21.7998H14.7998V20H8.7998V21.7998H7V20H4.86035L4.7207 19.9932C4.03505 19.9306 3.5 19.4111 3.5 18.7793V3.2207C3.5 2.58892 4.03501 2.06843 4.7207 2.00586L4.86035 2H19.1396ZM5.2002 18.4746H18.7998V3.52539H5.2002V18.4746Z' />
    </svg>
  );
};
